<script lang="ts">
	import { Router, Link, Route, navigate } from "svelte-routing";
	import Login from "./views/Login.svelte";
	import ResetPassword from "./views/ResetPassword.svelte";
	import ForgotPassword from "./views/ForgotPassword.svelte";
	import Layout from "./containers/Layout.svelte";
	import NotFound from "./views/NotFound.svelte";
	import OverlaySpinner from "../src/components/OverlaySpinner/OverlaySpinner.svelte";
	import { loadSpinner } from "../src/store/store";
	export let url = "";
</script>

<Router {url}>
	<div>
		<Route path="/login" component={Login} />
		<Route path="/reset-password/*" component={ResetPassword} />
		<Route path="/forgot-password/*" component={ForgotPassword} />
		<Route path="/not-found" component={NotFound} />
		<Route path="/*" component={Layout} />
	</div>
</Router>

{#if $loadSpinner}
	<OverlaySpinner />
{/if}
